import { useClient } from "#/hook/useClient";
import { hexToRgba } from "#/utils/ColorUtils";
import { Menu, UnstyledButton } from "@mantine/core";
import { IconCheck, IconChevronDown } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";

const LANGUAGES = [
  { code: "en", label: "English", flag: "🇬🇧" },
  { code: "fr", label: "Français", flag: "🇫🇷" },
  { code: "es", label: "Español", flag: "🇪🇸" },
  { code: "de", label: "Deutsch", flag: "🇩🇪" },
  { code: "it", label: "Italiano", flag: "🇮🇹" },
] as const;

const LanguageSelector = () => {
  const { i18n } = useTranslation();
  const { client } = useClient();

  const themeColor = client?.color ?? "#3f81ef";

  const currentLang =
    LANGUAGES.find((l) => l.code === i18n.language) ?? LANGUAGES[0];

  return (
    <Menu shadow="lg" width={180} position="bottom-end" withArrow>
      <Menu.Target>
        <UnstyledButton
          className="flex items-center gap-1.5 px-3 h-full bg-white rounded-lg transition-colors cursor-pointer hover:brightness-90 !border-2 !border-solid"
          style={{
            borderColor: hexToRgba(themeColor, 0.3),
            color: themeColor,
          }}
        >
          <span className="text-lg leading-none">{currentLang.flag}</span>
          <span className="text-sm font-semibold tracking-wide">
            {currentLang.code.toUpperCase()}
          </span>
          <IconChevronDown size={14} className="text-current" />
        </UnstyledButton>
      </Menu.Target>
      <Menu.Dropdown className="rounded-lg py-1">
        {LANGUAGES.map((lang) => (
          <Menu.Item
            key={lang.code}
            onClick={() => i18n.changeLanguage(lang.code)}
            rightSection={
              i18n.language === lang.code ? (
                <IconCheck size={14} color={themeColor} />
              ) : null
            }
            className="py-2"
          >
            <div className="flex items-center gap-2.5">
              <span className="text-base leading-none">{lang.flag}</span>
              <span
                className={`text-sm ${i18n.language === lang.code ? "font-semibold" : ""}`}
              >
                {lang.label}
              </span>
            </div>
          </Menu.Item>
        ))}
      </Menu.Dropdown>
    </Menu>
  );
};

export default LanguageSelector;
